import type MenuItem from '../../Models/MenuItem';
import { useTranslation } from 'react-i18next';
import React, { useContext, useState } from 'react';
import Styles from '../Menu/Menu.module.scss';
import MenuFavoriteItemLink from '../MenuFavoriteItemLink/MenuFavoriteItemLink';
import { DraggedMenuItemContext } from '../Menu/Menu';
import { normalize } from '@/Utility/StringFunctions';
import { DragDropProvider } from '@dnd-kit/react';

function FavoritesMenu({ title, menuItems, onAdd, onRemove, onOrder, filter }: Readonly<{
    title: string; menuItems: MenuItem[]; onAdd: Function; onRemove: Function; onOrder: Function; filter: string;
}>): React.ReactElement {
    const { t } = useTranslation();
    const [hidden, setHidden] = useState<boolean>(false);
    const { get: getDragged } = useContext(DraggedMenuItemContext);

    const toggle = (): void => setHidden(!hidden);

    const dropElement = (event: any): void => {
        event.stopPropagation();
        if (menuItems.findIndex((x) => x.Text === getDragged().Text) >= 0) {
            return;
        }
        onAdd(event, getDragged());
    };
    const enterDrag = (event: any): void => {
        event.stopPropagation();
    };
    const dragOver = (event: any): void => {
        event.stopPropagation();
        event.preventDefault();
    };
    const onOrderDrop = (result: any): void => {
        onOrder(result);
    };
    const getItems = (): MenuItem[] => {
        if (!filter || filter === '') {
            return menuItems;
        }
        return menuItems.filter((x) => normalize(t(x.ID)).includes(normalize(filter)));
    };

    return (
        <ul className={Styles.leftNav}>
            {/* Title */}
            <button
                className={Styles.navHeader}
                onDrop={dropElement}
                onDragEnter={enterDrag}
                onDragOver={dragOver}
                onClick={toggle}
            >
                <div style={{ fontSize: 11, fontWeight: 'regular' }}>{title}</div>
                <span className="material-symbols-outlined">{ hidden ? 'keyboard_arrow_right' : 'keyboard_arrow_down'}</span>
            </button>

            {/* Items */}
            <ul
                aria-label="List and dropzone for favorite menu items"
                onDrop={dropElement}
                onDragEnter={enterDrag}
                onDragOver={dragOver}
                hidden={hidden}
            >
                <DragDropProvider onDragEnd={onOrderDrop}>
                    {getItems().map((item, i) => (
                        <MenuFavoriteItemLink key={item.ID} index={i} primary={t(item.WorklistFilterID != null ? item.Text : item.ID)} to={item.ID} sub={false} full={item} icon={item.IconClass} onRemove={onRemove} />
                    ))}
                </DragDropProvider>
            </ul>
        </ul>
    );
}

export default FavoritesMenu;
